import { ImageBackground, Pressable } from "react-native";

import { Col, Icon, TextBody } from "../lib";
import {
  Attention,
  getDateFromServerTimestamp,
  useUserVideoDelete,
} from "../services";
import { colors, createStyles } from "../theme";
import { useCallback } from "react";
import { TimelineListItemFooter } from "./timeline-list-item-footer";

type Props = {
  id: number;
  url: string;
  thumbnail?: string;
  createdAt: number;
  processed: boolean;
  onPress: (url: string) => void;
  onDelete: () => void;
};

export function VideoListItem({
  createdAt,
  processed,
  thumbnail,
  id,
  url,
  onPress,
  onDelete,
}: Props) {
  // Data
  const [deleteVideo] = useUserVideoDelete({ id });

  // Handlers
  const handlePress = useCallback(() => {
    if (processed) {
      onPress(url);
    }
  }, [onPress, url, processed]);

  const handleDelete = useCallback(async () => {
    const ok = await Attention.confirm(
      "Delete Video",
      "Are you sure you want to delete this video?",
      { destructive: true },
    );

    if (ok) {
      await deleteVideo();

      onDelete();
    }
  }, [deleteVideo, onDelete]);

  // Render
  return (
    <Col m="4" style={$.container}>
      {!!thumbnail && processed ? (
        <Pressable onPress={handlePress}>
          <ImageBackground
            source={{ uri: thumbnail }}
            resizeMode="cover"
            style={$.thumbnail}
          >
            <Icon em name="play-circle-outline" size={48} />
          </ImageBackground>
        </Pressable>
      ) : (
        <Col px="4" py="2">
          <TextBody color="onSurfaceDim" style={$.italic}>
            Video will show here once approved.
          </TextBody>
        </Col>
      )}

      <TimelineListItemFooter
        createdAt={getDateFromServerTimestamp(createdAt)}
        published={processed}
        onDelete={handleDelete}
        variant="video"
      />
    </Col>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "surface",
    borderRadius: "4",
    overflow: "hidden",
  },
  thumbnail: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "surfaceDim",
    borderBottomWidth: 1,
    borderBottomColor: colors.outline,
    minHeight: 250,
  },
  italic: {
    fontStyle: "italic",
  },
});
